import { Alert } from '@mui/material';
import { useDeleteItemsMutation } from 'api/ordering-service/ordering-service';
import ConfirmationDrawer from 'components/drawers/confirmation-drawer/confirmation-drawer.component';
import { useBulkEditDataGridContext } from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

type ItemsDeleteDrawerProps = {
  open: boolean;
  close: () => void;
};

const ItemsDeleteDrawer = ({ open, close }: ItemsDeleteDrawerProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [triggerDeleteItems] = useDeleteItemsMutation();
  const { selectedRowIds } = useBulkEditDataGridContext();

  const onConfirmationValid = async () => {
    try {
      await triggerDeleteItems({ itemIds: selectedRowIds }).unwrap();
      enqueueSnackbar(
        t('ItemsDataGrid.additionalMenus.delete.successMessage'),
        {
          severity: 'success',
        },
      );
    } catch (_e) {}
  };

  return (
    <ConfirmationDrawer
      open={open}
      close={close}
      submitButtonLabel={t('drawer.itemsDeleteDrawer.submitButtonLabel')}
      onValid={onConfirmationValid}
      cancel={close}
      color="error"
    >
      <Alert severity="info">
        {t('ItemsDataGrid.additionalMenus.delete.alertMessage', {
          count: selectedRowIds.length,
        })}
      </Alert>
    </ConfirmationDrawer>
  );
};

export default ItemsDeleteDrawer;
